import React, { useState } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { IClinique, ISetSearchParams } from 'components/core/types'
import { css, StyleSheet } from 'aphrodite'
import { AppDispatch } from 'components/store/state/store'
import { updateCurrentClinique, updateCurrentStep } from 'components/core/state/actions'
import getCliniqueAddress from 'utils/getCliniqueAddress'
import OpenClosed from 'components/ui/OpenClosed'
import GreenArrow from 'assets/images/green-arrow.svg'
import WhiteArrow from 'assets/images/white-arrow.svg'
import { useTranslation } from 'react-i18next'
import useResponsive from 'hooks/useResponsive'

const mapDispatch = (dispatch: AppDispatch) => ({
  updateClinique: (cliniqueId: number, setSearchParams: ISetSearchParams) => {
    dispatch(updateCurrentClinique(cliniqueId, setSearchParams))
  },
  updateStep: (step: number, setSearchParams: ISetSearchParams) => {
    dispatch(updateCurrentStep(step, setSearchParams))
  },
})
const connector = connect(null, mapDispatch)

interface ICliniqueBlock extends ConnectedProps<typeof connector> {
  clinique: IClinique,
  fullLink?: boolean,
}

const CliniqueBlock = ({
  clinique,
  fullLink,
  updateClinique,
  updateStep,
}: ICliniqueBlock) => {
  const [, setSearchParams] = useSearchParams()
  const [isHover, setIsHover] = useState(false)
  const { t } = useTranslation()
  const { compareTag } = useResponsive()
  const handleClick = (cliniqueId: number) => {
    updateClinique(cliniqueId, setSearchParams)
    updateStep(3, setSearchParams)
  }
  const handleOver = () => setIsHover(true)
  const handleOut = () => setIsHover(false)
  const handleKey = () => (false)

  const {
    google_datas: {
      result: {
        opening_hours: {
          periods,
        } = {},
      } = {},
    } = {},
  } = clinique

  const styles = StyleSheet.create({
    block: {
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'space-between',
      direction: 'ltr',
      textAlign: 'left',
      borderTopStyle: 'dotted',
      borderTopWidth: 3,
      borderTopColor: 'rgba(105, 190, 40, .5)',
      padding: compareTag('md') ? '17px 25px' : '10px 5px',
    },
    title: {
      margin: '3px 0 1px',
    },
  })

  const inputActions = (link) => (link ? {
    onClick: () => handleClick(clinique.id),
    onMouseOver: handleOver,
    onFocus: handleOver,
    onMouseOut: handleOut,
    onBlur: handleOut,
    onKeyUp: handleKey,
    onKeyDown: handleKey,
    onKeyPress: handleKey,
    role: 'link',
    tabIndex: 0,
  } : {})

  const titleStyle = css(styles.title)
  /* eslint-disable react/jsx-props-no-spreading */
  return (
    <div className={css(styles.block)} {...inputActions(fullLink)}>
      <div>
        {!!periods && (<OpenClosed clinique={clinique} />)}
        <div
          className={`${titleStyle} tw-text-sm-5 md:tw-text-xl-5 tw-font-extrabold tw-tracking-widest tw-uppercase`}
          {...inputActions(!fullLink)}
        >
          {clinique.title}
        </div>
        <div className="tw-text-xs-5 md:tw-text-lg">{getCliniqueAddress(clinique)}</div>
      </div>
      <div className="tw-hidden md:tw-flex md:tw-items-center md:tw-w-20" {...inputActions(!fullLink)}>
        <img
          src={isHover ? WhiteArrow : GreenArrow}
          alt={t('take-appointment')}
          className="tw-w-full tw-h-3.5 md:tw-h-7"
        />
      </div>
    </div>
  )
}
CliniqueBlock.defaultProps = {
  fullLink: true,
}
export default connector(CliniqueBlock)
